var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5618 1.58615C15.0077 0.13795 16.9923 0.137948 17.4382 1.58615L19.806 9.2773C20.1323 10.3372 21.097 11.0692 22.1999 11.0692H29.987C31.4141 11.0692 32.0753 12.9666 30.8867 13.878L24.4847 18.787C23.6326 19.4404 23.2819 20.5675 23.599 21.5974L26.0198 29.4608C26.4769 30.9456 24.8224 32.0579 23.6819 31.1834L17.5082 26.4495C16.615 25.7646 15.385 25.7646 14.4918 26.4495L8.31808 31.1834C7.17762 32.0579 5.52306 30.9456 5.98018 29.4608L8.40104 21.5974C8.71812 20.5675 8.36736 19.4404 7.51533 18.787L1.11325 13.878C-0.0753308 12.9666 0.58587 11.0692 2.01297 11.0692H9.80006C10.903 11.0692 11.8677 10.3372 12.194 9.2773L14.5618 1.58615Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "star.75b3837c1ef23f2dde5f48ec16ac371e.svg";